import React, { Component } from "react";

function App(props) {
    const { data, i18n, themeColor } = props;
    const { report } = i18n;
    const { mappingObj } = report;

    const getResult = value => {
        let params = {}, baseWidth = 200;
        switch(value) {
            case "Low":
                params = {
                    width: baseWidth * 0.2,
                    text: "低等" 
                }
                break;
            case "Low To Medium":
                params = {
                    width: baseWidth * 0.4,
                    text: "低到中等" 
                }
                break;
            case "Medium":
                params = {
                    width: baseWidth * 0.6,
                    text: "中等" 
                }
                break;
            case "Medium To High":
                params = {
                    width: baseWidth * 0.8,
                    text: "中到高等" 
                }
                break;
            case "High":
                params = {
                    width: baseWidth,
                    text: "高等" 
                }
                break;
        }
        return <div className="mapping-mobile-box-inner">
			<div className="mapping-mobile-inner-box" style={{width: (params.width / 100 + "rem")}}></div>
			<div className="mapping-mobile-inner-text">{i18n.lang == "en_us" ? value : params.text}</div>
		</div>
    }

    return (
        <div className="mapping-mobile-wrap">
            <div className="mapping-mobile-table">
            	<div className="mapping-mobile-table-tr">
            		<div className="mapping-mobile-box bgColor14">
            			<div>{mappingObj.stressReaction}</div>
                        { getResult(data.stress_reaction) }
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText2}：</span>
						<span>{report.nervousness}</span>
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText3}：</span>
						<span>{report.disgust + "、" + report.fear + "、" + report.contempt + "、" + report.angry + "、" + report.sadness}</span>
					</div>
            	</div>
            	<div className="mapping-mobile-table-tr">
            		<div className="mapping-mobile-box bgColor15">
            			<div>{mappingObj.outgoing}</div>
                        { getResult(data.outgoing) }
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText2}：</span>
						<span>{mappingObj.extravesion + "、" + mappingObj.selfConfidense}</span>
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText3}：</span>
						<span>{report.surprise + "、" + report.happines}</span>
					</div>
            	</div>
            	<div className="mapping-mobile-table-tr">
            		<div className="mapping-mobile-box bgColor16">
            			<div>{mappingObj.creativity}</div>
                        { getResult(data.creativity) }
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText2}：</span>
						<span>{mappingObj.innovation + "、" + report.curiosity}</span>
            		</div>
            	</div>
            	<div className="mapping-mobile-table-tr">
            		<div className="mapping-mobile-box bgColor17">
            			<div>{mappingObj.agreeableness}</div>
                        { getResult(data.agreeableness) }
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText2}：</span>
						<span>{mappingObj.empathy + "、" + mappingObj.disagreeing + "、" + mappingObj.trust + "、" + report.honesty}</span>
            		</div>
            	</div>
            	<div className="mapping-mobile-table-tr">
            		<div className="mapping-mobile-box bgColor18">
            			<div>{mappingObj.conscientiousness}</div>
                        { getResult(data.conscientiousness) }
            		</div>
            		<div className="mapping-mobile-table-td">
						<span className="mapping-mobile-table-td-label">{mappingObj.headerText2}：</span>
						<span>{report.passion + "、" + mappingObj.easyGoing}</span>
            		</div>
            	</div>
            </div>
        </div>
    );
}

export default App;
